import { useEffect, useRef, useState } from "react";

type State = "idle" | "saving" | "saved" | "error";

export function useAutosaveIndicator(debounceMs = 400, clearMs = 2000) {
  const [state, setState] = useState<State>("idle");
  const debounce = useRef<number | null>(null);
  const clearTimer = useRef<number | null>(null);

  // public API
  const begin = () => {
    // enter 'saving' after a small debounce so we don't flicker on quick taps
    if (debounce.current) window.clearTimeout(debounce.current);
    debounce.current = window.setTimeout(() => setState("saving"), debounceMs);
  };

  const succeed = () => {
    if (debounce.current) { window.clearTimeout(debounce.current); debounce.current = null; }
    setState("saved");
    if (clearTimer.current) window.clearTimeout(clearTimer.current);
    clearTimer.current = window.setTimeout(() => setState("idle"), clearMs);
  };

  const fail = () => {
    if (debounce.current) { window.clearTimeout(debounce.current); debounce.current = null; }
    setState("error");
  };

  useEffect(() => () => {
    if (debounce.current) window.clearTimeout(debounce.current);
    if (clearTimer.current) window.clearTimeout(clearTimer.current);
  }, []);

  return { state, begin, succeed, fail };
}